/**
 * @fileoverview gRPC-Web generated client stub for acompanha.dashboard.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/dashboard/v1/dashboard.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.dashboard = {};
proto.acompanha.dashboard.v1 = require('./dashboard_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.dashboard.v1.DashboardServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.dashboard.v1.DashboardServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.dashboard.v1.GetDashboardRequest,
 *   !proto.acompanha.dashboard.v1.GetDashboardResponse>}
 */
const methodDescriptor_DashboardService_GetDashboard = new grpc.web.MethodDescriptor(
  '/acompanha.dashboard.v1.DashboardService/GetDashboard',
  grpc.web.MethodType.UNARY,
  proto.acompanha.dashboard.v1.GetDashboardRequest,
  proto.acompanha.dashboard.v1.GetDashboardResponse,
  /**
   * @param {!proto.acompanha.dashboard.v1.GetDashboardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.dashboard.v1.GetDashboardResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.dashboard.v1.GetDashboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.dashboard.v1.GetDashboardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.dashboard.v1.GetDashboardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.dashboard.v1.DashboardServiceClient.prototype.getDashboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.dashboard.v1.DashboardService/GetDashboard',
      request,
      metadata || {},
      methodDescriptor_DashboardService_GetDashboard,
      callback);
};


/**
 * @param {!proto.acompanha.dashboard.v1.GetDashboardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.dashboard.v1.GetDashboardResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.dashboard.v1.DashboardServicePromiseClient.prototype.getDashboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.dashboard.v1.DashboardService/GetDashboard',
      request,
      metadata || {},
      methodDescriptor_DashboardService_GetDashboard);
};


module.exports = proto.acompanha.dashboard.v1;

